import {MOON_500} from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

export const Placeholder = styled.div`
  color: ${MOON_500};
`;
